import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import RutaProtegida from './components/RutaProtegida';
import Home from './pages/Home';
import Login from './pages/Login';
import Taller from './pages/Taller';
import Instructor from './pages/Instructor';
import Admin from './pages/Admin';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={
            <RutaProtegida rol="alumno"><Home /></RutaProtegida>
          } />
          <Route path="/taller/:id" element={
            <RutaProtegida rol="alumno"><Taller /></RutaProtegida>
          } />
          <Route path="/instructor" element={
            <RutaProtegida rol="instructor"><Instructor /></RutaProtegida>
          } />
          <Route path="/admin" element={
            <RutaProtegida rol="admin"><Admin /></RutaProtegida>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;